import { videoEditor } from '@mi-front/api-clients';

export interface RenderedVideoUrlResult {
  /** Signed video URL when available; null while loading or when render is not completed. */
  url: string | null;
  /** True while the URL is being fetched (render completed but API request in progress). */
  isLoading: boolean;
}

/**
 * Returns the signed video URL for a project when its render job is completed.
 * Uses the video-editor API which returns the URL in the response body (no redirect).
 * Also returns isLoading so the UI can show a loading state (e.g. black placeholder) while fetching.
 */
export function useRenderedVideoUrl(project: videoEditor.Project | null): RenderedVideoUrlResult {
  const isRenderCompleted =
    !!project?.renderJob &&
    project.renderJob.status === videoEditor.publicJobWithResultDtoStatusEnum.COMPLETED;

  const { data, isFetching } = videoEditor.useProjectRenderGetVideoUrl(
    project?.id ?? '',
    {
      download: true,
    },
    {
      query: {
        enabled: !!project && isRenderCompleted,
        refetchOnWindowFocus: false,
      },
    },
  );

  const isLoading = !!project && isRenderCompleted && isFetching;

  return {
    url: data?.url ?? null,
    isLoading,
  };
}
